import { useMutation, useQuery } from '@apollo/client'
import { GET_CURRENT_USER, GET_TIMEZONES } from './queries'
import {
  GetCurrentUserQuery,
  getTimezonesQuery,
  UploadFileVariables,
  UploadFileResult,
  DeleteFilesVariables,
  UpdateResourceVariables,
} from './types'
import { DELETE_FILES, UPLOAD_FILE, UPDATE_RESOURCE } from './mutations'

export const useCurrentUser = () =>
  useQuery<GetCurrentUserQuery>(GET_CURRENT_USER, {
    fetchPolicy: 'cache-first',
  })

export const useTimezones = () =>
  useQuery<getTimezonesQuery>(GET_TIMEZONES, {
    fetchPolicy: 'cache-first',
  })

export const useUploadFile = () =>
  useMutation<UploadFileResult, UploadFileVariables>(UPLOAD_FILE)

export const useDeleteFile = () =>
  useMutation<any, DeleteFilesVariables>(DELETE_FILES)

export const useUpdateResource = () =>
  useMutation<any, UpdateResourceVariables>(UPDATE_RESOURCE)
